import { get, isNil, pickBy } from 'lodash'
import { serializeInvoiceBuyerType } from '@/config/invoice'
import { invoicePrintStatusConfig } from '@/config/invoiceRecord'
import {
  showInvoiceLinkedWarning,
  showInvoicePrintResultToast,
} from '@/views/Invoice/helpers/printToast'

export const buildSalesPOSInvoiceBuyer = (formValue = {}) => {
  const type = get(formValue, 'type')
  const buyerType = serializeInvoiceBuyerType(type)
  const identifier = type === 'B' ? get(formValue, 'taxId') || null : null

  const buyer = {
    type: buyerType,
    email: get(formValue, 'email') || null,
    name: type === 'B' ? get(formValue, 'companyTitle') || identifier : null,
    identifier,
    carrierNum: type === 'carrier' ? get(formValue, 'carrierNum') || null : null,
    carrierType: type === 'carrier' ? get(formValue, 'carrierType') || null : null,
  }

  return pickBy(buyer, (v) => !isNil(v))
}

export const buildSalesPOSInvoicePayload = ({ invoiceOption } = {}) => {
  if (!invoiceOption?.buyer) return undefined
  return {
    buyer: invoiceOption.buyer,
  }
}

export const getSalesPOSInvoiceRecord = (data) => {
  return get(data, 'InvoiceRecord')
}

export const isSalesPOSInvoiceFailed = (record) => {
  return ['invalid', 'failed'].includes(get(record, 'status'))
}

export const isSalesPOSInvoiceIssued = (record) => {
  return get(record, 'status') === 'issued'
}

export const isSalesPOSInvoicePrintPending = (record) => {
  return get(record, 'printStatus') === invoicePrintStatusConfig.pendingPrint.value
}

export const isSalesPOSInvoicePrintFailed = (record) => {
  return get(record, 'printStatus') === invoicePrintStatusConfig.printFailed.value
}

export const hasSalesPOSInvoicePrintStatus = (record) => {
  return [
    invoicePrintStatusConfig.pendingPrint.value,
    invoicePrintStatusConfig.printed.value,
    invoicePrintStatusConfig.printFailed.value,
  ].includes(get(record, 'printStatus'))
}

export const isSalesPOSInvoicePollingTerminal = (data) => {
  const record = getSalesPOSInvoiceRecord(data)
  if (!record || record.status === 'pending') return false
  if (isSalesPOSInvoiceFailed(record)) return true
  return !isSalesPOSInvoicePrintPending(record)
}

export const getSalesPOSInvoiceFailMessage = (record) => {
  return get(record, 'invalidReason')
}

export const getSalesPOSInvoicePrintFailMessage = (record) => {
  return get(record, 'invalidReason')
}

export const showSalesPOSInvoiceResultToast = ({ record, salesRecordOrderNo, router }) => {
  if (!record) return

  if (isSalesPOSInvoiceFailed(record)) {
    window.$message.error({
      message: getSalesPOSInvoiceFailMessage(record),
    })
    showInvoiceLinkedWarning({
      messageBefore: '銷售已完成，發票開立失敗。請 前往',
      linkText: '銷售紀錄詳情頁',
      messageAfter: '重新開立',
      onClick: () => {
        router.push({
          name: 'SalesRecordList',
          query: {
            orderNo: salesRecordOrderNo || get(record, 'sourceNo'),
            view: 'detail',
          },
        })
      },
    })
    return
  }

  if (isSalesPOSInvoicePrintFailed(record)) {
    window.$message.error({
      message: getSalesPOSInvoicePrintFailMessage(record),
    })
    showInvoicePrintResultToast({ record, router })
    return
  }

  showInvoicePrintResultToast({ record, router })
}
